export function getMenu(state) {
  return state.menu;
}

export function getMenuKey(state) {
  return state.menuKey;
}
